import ReferralBase from "../auth/ReferralBase";

class AgentLandingPluggable extends  ReferralBase {
    render() {
        console.log('Agent:', this.state.agent);
        return this.renderAgentInfo();
    }
}

export default AgentLandingPluggable;